module.exports = __webpack_public_path__ + "b8ee628aa7c250cd028e18a073daee5f.pdf";